import {checkCookie, deleteCookie} from '../utils/cookies';

function toggleItem(item, shouldShow) {
    if (item) {
        item.classList.toggle('secondary-navigation__item--hidden', !shouldShow);
    }
}

export default function checkPlenigoSession() {
    if (checkCookie('juve_plus_check_')) {
        const url = new URL('/wp-json/auth/v1/authentication/', window.location.origin);

        fetch(url, {
            method: 'GET', credentials: 'include',
        })
            .then((response) => response.json())
            .then((data) => {
                const login = document.querySelector('.js-header-login');
                const profil = document.querySelector('.js-header-profile');
                const logout = document.querySelector('.js-header-logout');

                if (data.status) {
                    toggleItem(login, false);
                    toggleItem(profil, true);
                    toggleItem(logout, true);

                    return;
                }

                toggleItem(login, true);
                toggleItem(profil, false);
                toggleItem(logout, false);

                deleteCookie('sso_session');
                deleteCookie('juve_plus');
            })
            .catch((error) => {
                console.error('Fehler beim Abrufen der Session-Information:', error);
            });
    }
}
